export default __webpack_public_path__ + "static/media/Background_00243.cf81fa9d.png";